import ToastificationContent from '../@core/components/toastification/ToastificationContent.vue'

let toastInstance = null // Variable to hold the toast function

const toastService = {
  setToast(toast) {
    toastInstance = toast // Store the received toast function
  },

  showToast({
    title, icon = 'AlertTriangleIcon', variant = 'info', ...otherProps
  }) {
    if (toastInstance) {
      toastInstance({
        component: ToastificationContent,
        props: {
          title,
          icon,
          variant,
          ...otherProps,
        },
      })
    } else {
      console.error('Toast function not yet set') // Handle if toast function is not set
    }
  },

  warning(title, otherProps = {}) {
    toastService.showToast({ title, variant: 'warning', ...otherProps })
  },

  error(title, otherProps = {}) {
    toastService.showToast({ title, variant: 'danger', ...otherProps })
  },

  success(title, otherProps = {}) {
    toastService.showToast({ title, variant: 'success', ...otherProps })
  },

  info(title, otherProps = {}) {
    toastService.showToast({ title, ...otherProps })
  },
}

export default toastService
